module.exports = __webpack_public_path__ + "media/images/icons/SVG/055-67837ea45b6419df1fa7546d97d5119c.svg";